<template>
	<div class="add-expert">

		<div class="statusBox">
			{{ item.status == 0 ? "待支付" : "" }}
			<!-- // 0-待审核，1-同意，2-拒绝 3-取消申请 -->

			{{ item.status == 1 && item.refundStatus == -1 ? "已支付" : "" }}
			{{ item.status == 1 && item.refundStatus == 0 ? "退款审核中" : "" }}
			{{ item.status == 1 && item.refundStatus == 1 ? "已退款" : "" }}
			{{ item.status == 1 && item.refundStatus == 2 ? "退款失败" : "" }}
			{{ item.status == 1 && item.refundStatus == 3 ? "已支付" : "" }}

			{{ item.status == 2 ? "已邮寄" : "" }}
			{{ item.status == 3 ? "已取消" : "" }}
			{{ item.status == 4 ? "已退款" : "" }}
			{{ item.status == 5 ? "已完成" : "" }}
		</div>
		<div class="address">
			<div class="province">
				{{ item.contactProvince }}
				{{ item.contactCity }}
				{{ item.contactArea }}
			</div>
			<div class="addressDetail">
				{{ item.contactAddress }}
			</div>
			<div class="province">
				<span>{{ item.contacts }}</span> <span style="margin-left: 10px;">{{ item.tel }}</span>
			</div>
		</div>

		<div class="content" v-if="(item.certs || []).length > 0">
			<div class="imgContent" v-for="(subItem, subIndex) in item.certs" :key="subIndex">
				<img :src="subItem.certUrl" alt="">
				<div class="imgRight">
					<div class="imgTop">
						{{ subItem.typeName }}
					</div>
				</div>
			</div>
		</div>

		<div class="detail">
			<div class="item">
				<div class="left">
					作品编号
				</div>
				<div class="right">
					{{ item.transactionId }}
				</div>
			</div>
			<div class="item">
				<div class="left">
					作者名字
				</div>
				<div class="right">
					{{ item.babyName }}
				</div>
			</div>
			<div class="item">
				<div class="left">
					订单编号
				</div>
				<div class="right">
					{{ item.orderSn }}
				</div>
			</div>
			<div class="item" v-if="item.trackingNo">
				<div class="left">
					物流编号
				</div>
				<div class="right">
					{{ item.trackingNo }}
				</div>
			</div>
			<div class="item" v-if="item.refundTransactionNo">
				<div class="left">
					退款编号
				</div>
				<div class="right">
					{{ item.refundTransactionNo }}
				</div>
			</div>
			<div class="item">
				<div class="left">
					下单时间
				</div>
				<div class="right">
					{{ item.addTime }}
				</div>
			</div>
			<div class="item" v-if="item.payTime">
				<div class="left">
					支付时间
				</div>
				<div class="right">
					{{ item.payTime }}
				</div>
			</div>
			<div class="item" v-if="item.deliveryTime">
				<div class="left">
					发货时间
				</div>
				<div class="right">
					{{ item.deliveryTime }}
				</div>
			</div>
			<div class="item" v-if="item.cancelTime && item.status == 3">
				<div class="left">
					取消时间
				</div>
				<div class="right">
					{{ item.cancelTime }}
				</div>
			</div>

			<div class="item">
				<div class="left">
					运费
				</div>
				<div class="right" style="color: red;">
					¥{{ item.amount }}
				</div>
			</div>
			<div class="item">
				<div class="left">
					支付方式
				</div>
				<div class="right">
					微信
				</div>
			</div>



		</div>

		<div class="btns">
			<!-- 状态 ，0-未支付，1-已支付，2-已邮寄，3-已取消，4-已退款 5-已完成-->
			<div class="gray" v-if="item.status == 0 || item.status == 3 || item.status == 4" @click="handleDelete">删除订单</div>
			<div class="action" v-if="item.status == 0" @click="getPayInfo(item.id)">去支付</div>

			<div class="gray" v-if="item.status == 1 && item.refundStatus == -1" @click="handleRefund">申请退款</div>
			<div class="gray" v-if="item.status == 1 && item.refundStatus == 0" @click="handleCancelRefund">取消退款</div>
			<div class="gray" v-if="item.status == 1 && item.refundStatus == 1" @click="handleDelete">删除订单</div>
			<div class="gray" v-if="item.status == 1 && item.refundStatus == 2" @click="handleRefund">申请退款</div>
			<div class="gray" v-if="item.status == 1 && item.refundStatus == 3" @click="handleRefund">申请退款</div>
			<div class="action" v-if="item.status == 2" @click="handleReceive">确认收货</div>
		</div>
	</div>
</template>

<script>


import {
	certDetail,
	certPay,
	certDelete,
	certReceive,
} from "@/utils/api/cert";

import {
	signature
} from "@/utils/mixin/wx-js-sdk-signature";
import {
	wxlogin
} from "@/utils/mixin/wxlogin";
import { validate } from "@/utils/mixin/validate";
import Crop from "@/components/pub/CompressCrop.vue";
import { certCancel, certCancelRefund } from "../../utils/api/cert";

export default {
	mixins: [signature, wxlogin, validate],

	components: {
		Crop
		// SignTitle
	},
	data() {
		return {
			TT: {},
			openid: '',
			id: '',
			item: {},
			canPay: false,
		};
	},

	mounted() {
		this.id = this.$route.query.id || ''


		this.getDetail()
	},
	methods: {
		// 确认收货
		handleReceive() {
			var that = this
			that.$Dialog.confirm({
				message: "您确定要已经收货吗?"
			}).then(() => {

				certReceive({
					id: that.item.id
				}).then(res => {
					if (res.code == 20000) {
						that.$root.$toast.fail("已收货");
						that.$router.back()
					}
				})

			}).catch(() => {
				// on cancel
			});
		},
		// 取消退款
		handleCancelRefund() {
			var that = this
			that.$Dialog.confirm({
				message: "您确定要取消退款吗?"
			}).then(() => {

				certCancelRefund({
					id: that.item.refundId
				}).then(res => {
					if (res.code == 20000) {
						that.$root.$toast.fail("已取消退款");
						that.$router.back()
					}
				})

			}).catch(() => {
				// on cancel
			});
		},

		// 申请退款
		handleRefund() {
			var that = this
			that.$Dialog.confirm({
				message: "您确定要申请退款吗?"
			}).then(() => {

				certCancel({
					id: that.item.id,
				}).then(res => {
					if (res.code == 20000) {
						that.$root.$toast.fail("已申请退款");

						that.$router.back()

					}


				})

			}).catch(() => {
				// on cancel
			});
		},

		// 删除
		handleDelete() {
			var that = this
			that.$Dialog.confirm({
				message: "您确定要删除订单吗?"
			}).then(() => {

				certDelete({
					id: that.item.id
				}).then(res => {
					if (res.code == 20000) {
						that.$root.$toast.fail("已删除");
						that.$router.back()
					}
				})

			}).catch(() => {
				// on cancel
			});
		},


		// 获取详情
		getDetail() {
			certDetail({
				id: this.id
			}).then(res => {
				if (res.code == 20000) {
					var element = res.data
					var certs = []
					if (element.certUrl) {
						var item = {
							certUrl: element.certUrl,
							typeName: '获奖证书',
						}
						certs.push(item)
					}
					if (element.practiceUrl) {
						var item = {
							certUrl: element.practiceUrl,
							typeName: '实践证书',
						}
						certs.push(item)
					}
					element.certs = certs;

					// 已支付状态:
					// 0-待审核，1-同意，2-拒绝 3-取消申请
					var refundStatus = -1
					var rejectReason = ''
					var refundId = ''
					if (element.status == 1) {
						var certOrderRefundTbl = element.certOrderRefundTbl || []
						if (certOrderRefundTbl.length > 0) {
							// 已经申请退款
							var refundItem = certOrderRefundTbl[0];
							refundId = refundItem.id
							refundStatus = refundItem.status
							rejectReason = refundItem.rejectReason || ''

							if (rejectReason.length > 0) {
								this.$Dialog.alert({
									title: '退款被拒理由',
									message: rejectReason
								}).then(() => {



								}).catch(() => {
									// on cancel
								});
							}


						} else {

							// 没有申请退款


						}
					}
					element.refundStatus = refundStatus
					element.rejectReason = rejectReason
					element.refundId = refundId

					this.item = element;

				}
			})
		},


		// wxlogin callback 微信登录回调
		wxLoginCallback() {

			const { id } = this.$route.query;
			let params = {};
			if (id) params.id = id;
			// 刷新页面js权限
			// this.$root.mipLink("/cert/detail", params);
		},


		getPayInfo(id) {
			var that = this
			// 检测用户信息
			// const wxinfo = that.$store.state.wxUserInfo;
			// if (!wxinfo) {
			// 	that.toAuthorizationPage("wxLoginCallback");
			// 	return
			// } else {
			// 	console.log('wxinfo == ', wxinfo)
			// 	that.openid = wxinfo.openid
			// }

			const openid = localStorage.getItem('open_id')
			if (!openid) {
				that.toAuthorizationPage("wxLoginCallback");
				return
			} else {
				that.openid = openid
			}

			// 			【】 
			// 恭喜您在参加第二十九届全国中小学生绘画书法作品比赛中获奖。
			// 1.电子证书与纸质证书同等作用于证明参赛成绩，可自行下载后打印使用。
			// 2.比赛组委会原则上不提供纸质证书。
			// 3.如需要纸质证书，可申领，组委会免费印制并签发。申领者应知晓此为个人需求，须自行承担配送物流费。第三方提供配送物流服务费为25元/件。
			// 4.申领须于  年  月   前提交，比赛组委会在收到申请后30个工作日内委托第三方物流服务单位配送。过期不再接受纸质证书申请。
			var activityName = that.item.activityName
			var fee = that.item.amount
			var time = that.item.applyCertEndTime || ''
			var timeTips = ''
			if (time.length > 0) {
			 timeTips = `4.申领须于${time}前提交，比赛组委会在收到申请后30个工作日内委托第三方物流服务单位配送。过期不再接受纸质证书申请。`
			}
			var message = `恭喜您在参加${activityName}比赛中获奖。\n1.电子证书与纸质证书同等作用于证明参赛成绩，可自行下载后打印使用。\n2.比赛组委会原则上不提供纸质证书。\n3.如需要纸质证书，可申领，组委会免费印制并签发。申领者应知晓此为个人需求，须自行承担配送物流费。第三方提供配送物流服务费为${fee}元/件。\n${timeTips}`
		
			that.$Dialog.confirm({
				title: '纸质证书申领提示',
				message: `<div style="text-align: left;">${message}</div>`,
			}).then(() => {

					certPay({
						id: id,
						openid: that.openid
					}).then(res => {
						if (res.code == 20000) {
							let data = res.data;
							that.TT = data

							that.onBridgeReady()
						}
					})

				}).catch(() => {
					// on cancel
					that.$router.go(-1);

				});



		},

		onBridgeReady() {
			let that = this;
			let TT = that.TT;
			if (typeof WeixinJSBridge == "undefined") {
				that.$root.$toast.fail("请在微信中打开完成支付");
			} else {
				let dataTT = {
					appId: TT.appId,
					timeStamp: TT.timeStamp,
					nonceStr: TT.nonceStr,
					package: TT.package,
					signType: TT.signType,
					paySign: TT.paySign,
				};
				WeixinJSBridge.invoke(
					"getBrandWCPayRequest",
					dataTT,
					(res) => {
						if (res.err_msg == "get_brand_wcpay_request:ok") {
							that.$root.$toast.success('支付成功');
							that.$router.back()
							// 使用以上方式判断前端返回,微信团队郑重提示：
							//res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
						} else if (res.err_msg == "get_brand_wcpay_request:cancel") {
							that.$root.$toast.success('支付取消,请重新支付');
						} else if (res.err_msg == "get_brand_wcpay_request:fail") {
							that.$root.$toast.success('支付失败,请重新支付');
						}
					}
				);

			}
		},
	},



};
</script>

<style lang="scss" scoped>
.add-expert {
	overflow: hidden;
	background: #F9F9FA;
	min-height: 100vh;

	.content {
		border-radius: 15px;
	}

	.tags {
		.van-tag {
			height: 32px;
			margin-left: 3px;
			margin-bottom: 3px;
			border-radius: 4px;
			border: #f2f2f2;
			min-width: 60px;
			background-color: #ecf5ff;
			color: #666;
			font-size: 12px;
			text-align: center;
			display: inline-block;
			line-height: 26px;
		}
	}

	.create {
		margin: 0 auto;
		width: 254px;
		margin-top: 40px;
		margin-bottom: 60px;

		.van-button {
			border-radius: 16px;
			width: 254px;
			height: 32px;
		}
	}
}
</style>
<style lang="scss">
@import "../../assets/css/customer.scss";

.add-expert {
	text-align: left;
	padding-bottom: 75px;
	margin-bottom: 1px;

	.van-cell {
		&::after {
			border: none;
		}
	}

	.van-uploader {
		@include from-upload-style;
	}

	.custom-title {
		color: #646566;
	}

	.custom-tit {
		font-size: 12px;
		color: #ccc;
	}

	.expert-userImg {
		text-align: left;
		padding-top: 10px;
		padding-left: 10px;
		background: #fff;
	}

	.custom-span {
		color: #ccc;
	}

	.affixs-label {
		width: unset;

		&+.van-field__value {
			display: none;
		}
	}
}

.statusBox {
	background-color: #fff;
	font-weight: bold;
	font-size: 24px;
	color: #333;
	border-radius: 10px;
	padding: 15px;
	margin: 15px 15px 0;
}

.address {
	border-radius: 10px;
	background-color: #fff;
	padding: 15px;
	margin: 15px 15px 0;

	.province {
		font-size: 13px;
		color: #666;
	}

	.addressDetail {
		padding: 5px 0;
		font-weight: bold;
		font-size: 16px;
		color: #333;
	}
}


.content {
	margin: 15px 15px 0;
	border-radius: 10px;
	background-color: #fff;
	padding: 15px 15px 1px;

	.imgContent {
		display: flex;
		text-align: left;
		margin-bottom: 15px;

		img {
			width: 100px;
			height: 70px;
			border-radius: 10px;
		}

		.imgRight {
			margin-left: 10px;
			flex: 1;

			.imgTop {
				font-weight: bold;
				color: #333;

			}

			.imgBottom {
				margin-top: 10px;
				color: #666;
			}
		}
	}

	.fee {
		padding-bottom: 15px;
		text-align: right;
		color: #666;

		span {
			font-weight: bold;
			color: #333;
		}
	}
}

.detail {
	padding: 6px 15px;
	background-color: #fff;
	border-radius: 10px;
	margin: 15px 15px 0;

	.item {
		display: flex;
		justify-content: space-between;
		align-items: center;
		color: #666;
		padding: 6px 0;
	}
}

.btns {
	padding-right: 15px;
	background-color: #fff;
	position: fixed;
	left: 0;
	right: 0;
	bottom: 0;
	border-top: 1px solid #eee;
	display: flex;
	justify-content: flex-end;

	.action {
		margin-top: 15px;
		margin-left: 15px;
		margin-bottom: 15px;
		height: 30px;
		line-height: 30px;
		background-color: #31D076;
		color: #fff;
		border-radius: 15px;
		padding: 0 10px;
	}

	.gray {
		margin-top: 15px;
		margin-left: 15px;
		margin-bottom: 15px;
		height: 30px;
		line-height: 30px;
		border: 1px solid #C9C9C9;
		color: #666;
		border-radius: 15px;
		padding: 0 10px;
	}
}
</style>
